export type Observer = (...args: any[]) => void;

export default class Observable {
	observers: Observer[] = [];

	notify(data: any) {
		this.observers.forEach((observer) => { observer(data); });
	}

	subscribe(observer: Observer) {
		this.observers.push(observer);
	}

	unsubscribe(observer: Observer) {
		[...this.observers].forEach((obs, index) => {
			if (obs === observer) {
				this.observers.splice(index, 1);
			}
		});
	}
}
